export default {
	state: {
		searchData: {},
	},
	mutations: {
		setSearchData(state, data) {
			state.searchData = data;
		},
	},
	actions: {
		setSearchDataAction({ commit }, params) {
			commit('setSearchData', params);
		},
	},
};
